import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import router from "./router";
Vue.config.productionTip = false;
import apiFun from "@/api/api.js";
//  引入swiper轮播
import "swiper/dist/css/swiper.min.css";
//  引入swiper轮播的css
import "swiper/dist/js/swiper.min";
import globalMethod from "./static/js/index";
import moment from "moment";
Vue.prototype.$moment = moment;
Vue.use(ElementUI);
Vue.prototype.$apiFun = apiFun; //请求接口api
Vue.prototype.$globalMethod = globalMethod; //全局公共方法
//  c值
router.beforeEach(async (to, from, next) => {
  var navList = to.name;
  if (to.query.c == undefined) {
    sessionStorage.setItem("blu", "1");
  } else {
    sessionStorage.removeItem("blu");
  }
  var c = undefined;
  if (to.query.c != null || from.query.c != null) {
    c = to.query.c != null ? to.query.c : from.query.c;
  }
  if (to.query.c == null && c != undefined) {
    to.query.c = c;
    next({ path: to.path, query: to.query, params: to.params });
  } else {
    // Vue.prototype.$RouterDatac=JSON.stringify(to.query)
    Vue.prototype.$RouterDatac = to.query;
    next();
  }
  // 跳手机端
  var mobileAgent = new Array(
    "iphone",
    "ipod",
    "ipad",
    "android",
    "mobile",
    "blackberry",
    "webos",
    "incognito",
    "webmate",
    "bada",
    "nokia",
    "lg",
    "ucweb",
    "skyfire"
  );
  var browser = navigator.userAgent.toLowerCase();
  var isMobile = false;
  let host = window.location.hostname
    .replace("www", "wap")
    .replace("1788", "wap");
  if (!host.startsWith("wap.")) {
    host = host.replace("p.", "wap.");
  }

  let hrefValue = `https://${host}`;
  for (var i = 0; i < mobileAgent.length; i++) {
    if (browser.indexOf(mobileAgent[i]) != -1) {
      isMobile = true;
    }
  }
  if (isMobile) {
    if (navList == "Homepage") {
      hrefValue += "?c=" + to.query.c;
    } else if (
      navList == "GameCenter" ||
      navList == "RankingList" ||
      navList == "Hfive"
    ) {
      hrefValue += "?c=" + to.query.c;
    } else if (navList == "Search") {
      hrefValue += "?c=" + to.query.c;
    } else if (navList == "realTimeInfo") {
      hrefValue += "?c=" + to.query.c;
    } else if (navList == "GiftBag" || navList == "GiftBagDetailsw") {
      hrefValue += "?c=" + to.query.c;
    } else if (navList == "RealInfo" || navList == "InformationDetails") {
      hrefValue += "?c=" + to.query.c;
    } else if (navList == "customerDetails" || navList == "Customer") {
      hrefValue += "?c=" + to.query.c;
    } else if (navList == "GameDetails") {
      hrefValue += "/gameDetails?c=" + to.query.c + "&Id=" + to.query.id;
    } else if (navList == "appdown") {
      hrefValue += "/appDown?c=" + to.query.c + "&Id=" + to.query.id;
    } else {
      hrefValue += "?c=" + to.query.c;
    }
    location.href = hrefValue;
  }
});
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js